<template>
  <div class="cell-list border-bottom-1px">
    <div
      v-show="mask"
      class="cell-mask"
    />
    <ul>
      <li
        v-for="(item, index) in data"
        :key="index"
        class="cell-wrapper"
        :class="{ 'disabled': item.disabled, 'border-bottom-1px': index !== data.length - 1 }"
        @click="onChange(item, index, $event)"
      >
        <slot
          :data="item"
          :index="index"
          name="item"
        />
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    'multiple': {
      type: Boolean,
      required: false,
      default: false
    },
    // 触发选中，点击的元素className
    'element': {
      type: String,
      required: false,
      default: ''
    },
    'data': {
      type: Array,
      default: () => { }
    },
    'mask': {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: []
    }
  },
  methods: {
    onChange (item, index, ev) {
      if (item.disabled) return
      if (this.element) {
        const isParent = this.isParent(ev.target, document.querySelectorAll('.' + this.element)[index])
        if (!(ev.target.className.indexOf(this.element) !== -1 || isParent)) return
      }
      if (this.multiple) {
        this.$set(item, 'checked', !item.checked)
      } else {
        for (let one of this.data) {
          this.$set(one, 'checked', false)
        }
        this.$set(item, 'checked', !item.checked)
      }
      this.$emit('change', item, index)
    }
  }
}
</script>
<style lang="less" scoped>
.cell-list {
  // height: calc(100vh - 70px);
  overflow-y: auto;
  overflow-x: hidden;
  .cell-mask {
    position: fixed;
    width: 100%;
    height: 100%;
    background: #25262d;
    overflow: hidden;
    opacity: 0.4;
    z-index: 1;
  }
  ul {
    position: relative;
    background-color: #fff;
    z-index: 2;
  }
  li.cell-wrapper:after {
    transform-origin: 20px bottom;
  }
  .cell-wrapper.disabled {
    .icon-success {
      color: #5077aa !important;
      opacity: 0.5;
    }
  }
  .cell-wrapper:first-child {
    background-origin: border-box;
  }
  .item {
    display: flex;
    justify-content: space-between;
    height: 42px;
    line-height: 42px;
    font-size: 14px;
    padding: 0 12px;
    .icon-success {
      color: #5077aa;
      &.gray {
        color: #dbdbdb;
      }
    }
  }
}
</style>
